import { ENV } from '../../environment';

type Config = {
  writeKey: string;
};
const DevEnv: Config = {
  writeKey: '0EbYOMmmd0dy10FbaywJWOYEFYSiapxa',
};
const StagingEnv: Config = {
  writeKey: 'kqSnsfSlPwLyoyKhoT5rSgtkcC1Du8Cd',
};
const ProdEnv: Config = {
  writeKey: 'J2boxyHatShJLUQRRFIMqygD8gp2GkWD',
};

export const config: Config = ENV === 'development' ? DevEnv : ENV === 'production' ? ProdEnv : StagingEnv;
